export default {
    air: {
        list: [
            { id: 1, name: "数字赋能中心空调1", no: "190029", status: 1, office: "数字赋能中心" },
            { id: 2, name: "数字赋能中心空调2", no: "190028", status: 0, office: "数字赋能中心" },
            { id: 3, name: "数字赋能中心空调3", no: "190027", status: 1, office: "数字赋能中心" },
            { id: 4, name: "数字赋能中心空调4", no: "190026", status: 1, office: "数字赋能中心" },
            { id: 5, name: "数字赋能中心空调5", no: "190025", status: 0, office: "数字赋能中心" },
            { id: 6, name: "数字赋能中心空调6", no: "190024", status: 1, office: "数字赋能中心" },
        ],
        name: "空调",
        count: {
            online: 30,
            total: 32
        }
    },
    light: {
        list: [
            { id: 1, name: "数字赋能中心灯光1", no: "210126", status: 1, office: "数字赋能中心" },
            { id: 2, name: "数字赋能中心灯光2", no: "210125", status: 1, office: "数字赋能中心" },
            { id: 3, name: "数字赋能中心灯光3", no: "210124", status: 1, office: "数字赋能中心" },
            { id: 4, name: "数字赋能中心灯光4", no: "210123", status: 0, office: "数字赋能中心" },
            { id: 5, name: "数字赋能中心灯光5", no: "210122", status: 1, office: "数字赋能中心" },
            { id: 6, name: "数字赋能中心灯光6", no: "210121", status: 0, office: "数字赋能中心" },
        ],
        name: "灯光",
        count: {
            online: 100,
            total: 108
        }
    },
    curtain: {
        list: [
            { id: 1, name: "数字赋能中心窗帘1", no: "250717", status: 0, office: "数字赋能中心" },
            { id: 2, name: "数字赋能中心窗帘2", no: "250718", status: 1, office: "数字赋能中心" },
            { id: 3, name: "数字赋能中心窗帘3", no: "250715", status: 1, office: "数字赋能中心" },
            { id: 4, name: "数字赋能中心窗帘4", no: "250712", status: 1, office: "数字赋能中心" },
            { id: 5, name: "数字赋能中心窗帘5", no: "250711", status: 1, office: "数字赋能中心" },
            { id: 6, name: "数字赋能中心窗帘6", no: "250713", status: 1, office: "数字赋能中心" },
        ],
        name: "窗帘",
        count: {
            online: 84,
            total: 100
        }
    }
}